import { render } from "./bizClass.vue?vue&type=template&id=a8325220"
import script from "./bizClass.vue?vue&type=script&lang=js"
export * from "./bizClass.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__